import { BrowserRouter, Routes, Route } from 'react-router-dom';

//Components
import Navbar from './components/Navbar/Navbar';

//Pages
import Home from './pages/Home/Home';
import Ideen from './pages/Ideen/Ideen';
import AddIdee from './pages/Ideen/AddIdee';
import EditIdee from './pages/Ideen/EditIdee';

//CSS
//import './App.css';
//<BrowserRouter  basename={'/ideen/'}>
function App() {
  return (
<BrowserRouter >
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/ideen' element={<Ideen />} />
        <Route path='/ideen/addIdee' element={<AddIdee />} />
        <Route path='/ideen/editIdee/:id' element={<EditIdee />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
